import { URL } from "../../api/Api";
import { catchError, GET, POST, PUT } from "../axios/Axios";

export const PlanBillingCall = async (payload) => {
  try {
    const response = await POST(
      `${URL}/customers/payment/create-session`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const PlanBillingValidationCheck = async (payload) => {
  try {
    const response = await POST(
      `${URL}/customers/payment/validate`,
      payload,
      {}
    );
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const AllPlan = async () => {
  try {
    const response = await GET(`${URL}/adminpanel/all-plans`, {});
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const PlanCancel = async (payload) => {
  try {
    const response = await POST(`${URL}/customers/cancel-plan/`, payload, {});
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const PlanHistory = async () => {
  try {
    const response = await GET(`${URL}/customers/plan-history`, {});
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const NotificationCall = async () => {
  try {
    const response = await GET(`${URL}/customers/notification`, {});
    return response.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const NotificationPutCall = async (payload) => {
  try {
    const response = await PUT(`${URL}/customers/notification`, payload, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const disconnectDataConnector = async (payload) => {
  try{
    const response = await PUT(`${URL}/customers/data-connector/disconnect`, payload, {})
    return response;
  }catch(error){
    throw catchError(error);
  }
}

export const connectDataConnector = async (payload) => {
  try{
    const response = await POST(`${URL}/customers/data-connector/connect`, payload, {})
    return response;
  }catch(error){
    throw catchError(error);
  }
}

export const allDataConnector =  async (org_id) => {
  try{
    const response = await GET(`${URL}/adminpanel/data-connectors?${org_id}`, {})
    return response;
  }catch(error){
    throw catchError(error);
  }
}